// A team is either a national team (Copa de Seleções) or a club (Brasileirão, Premier League).
// Only NATIONAL teams get a country flag in the UI: club three-letter codes collide with FIFA
// trigrams ("CAM" → Cameroon, "GRE" → Greece), and club crests are licensed artwork we have no
// rights to redistribute. Gating per team rather than per competition also survives a club cup
// (Copa do Brasil), where the competition format is KNOCKOUT but the teams are still clubs.
export const TeamType = {
  National: 'NATIONAL',
  Club:     'CLUB',
} as const
export type TeamType = (typeof TeamType)[keyof typeof TeamType]

export function showsCountryFlag(teamType: TeamType | undefined): boolean {
  return teamType === TeamType.National
}

// Whether a fixture for this team has a meaningful home side. Clubs play at their own grounds
// in both league and cup football; our national-team competition is a neutral-venue tournament,
// where the home/away flag on a fixture is an artefact of the feed, not a real advantage.
export function playsHomeAndAway(teamType: TeamType | undefined): boolean {
  return teamType === TeamType.Club
}
